jQuery(document).ready(function ($) {
  //################################################################//
  //######*****   Radio and Checkbox
  //######*****   Custom radio and checkboxes
  //################################################################//

  //Add class to selected radios
  $('.c-form .gfield_radio li input[type="radio"]').change(function () {
    if ($(this).prop("checked") == true) {
      $(this)
        .parent()
        .addClass("is-checked")
        .siblings()
        .removeClass("is-checked");
    }
  });
  //Add class to selected Checkboxes
  $(
    '.c-form .gfield_checkbox li input[type="checkbox"], .c-form .gfield_checkbox div input[type="checkbox"]'
  ).change(function () {
    if ($(this).is(":checked")) {
      $(this).parent().addClass("is-checked");
    } else {
      $(this).parent().removeClass("is-checked");
    }
  });

  //Remove validation
  $(".c-form .gfield_radio .LV_validation_message").remove();
  $(".c-form .gfield_radio").mousedown(function () {
    $(".c-form .gfield_radio .LV_validation_message").remove();
  });

  $(".c-form .gfield_checkbox .LV_validation_message").remove();
  $(".c-form .gfield_checkbox ").mousedown(function () {
    $(".c-form .gfield_checkbox .LV_validation_message").remove();
  });

  $inputs = $(document)
    .find(".js-contact-main .gfield .medium")
    .not(".gform_hidden");

  $inputs.focus(function () {
    $(this).parent().parent().addClass("is-focused");
  });

  //Change checkout form forward field from text to date
  $("#pk_forward_order_date").prop("type", "date");

  //disable select2 shipping_country dropdown.
  // $("#shipping_country_field select").prop("disabled", true);
});

//Preference checkbox validation
(function () {
  if (document.querySelector("#my_account_preferences")) {
    const form = document.querySelector("#my_account_preferences");
    const checkboxes = form.querySelectorAll("input[type=checkbox]");
    const checkboxLength = checkboxes.length;
    const firstCheckbox = checkboxLength > 0 ? checkboxes[0] : null;

    function init() {
      if (firstCheckbox) {
        for (let i = 0; i < checkboxLength; i++) {
          checkboxes[i].addEventListener("change", checkValidity);
        }

        checkValidity();
      }
    }

    function isChecked() {
      for (let i = 0; i < checkboxLength; i++) {
        if (checkboxes[i].checked) return true;
      }

      return false;
    }

    function checkValidity() {
      const errorMessage = !isChecked()
        ? "At least one checkbox must be selected."
        : "";
      firstCheckbox.setCustomValidity(errorMessage);
    }

    init();
  }
})();
